uic-pagination {
    --uic-popover-panel-padding: 0;

    display: flex;
    align-items: center;

    uic-input-field,
    uic-input-field-number {
        --uic-input-field-min-width: calc(
            var(--uic-stretched-button-width) * 1.8
        );
        width: calc(var(--uic-stretched-button-width) * 1.8);
    }

    .uic-pagination__page-button {
        button {
            --uic-segmented-control-min-width: 0;
            --uic-icon-button-width: var(--uic-stretched-button-width);
        }
    }
}
